import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as conversation from '../conversation'

// TODO: Remove this attribute once DMS query supports querying for "created at"

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: conversation.RESOURCE.payload.dimension.partialId,
      partialId: conversation.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The timestamp when the conversation was created',
    isOptional: false,
    name: 'Created At',
    partialId: PartialId.Standard.create('createdAt'),
    type: core.common.value.types.Intrinsic.Date,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
